import React from 'react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';

// Region / state used to also discount local holidays; empty = deduced from the court or national only
export const RegionSelect = ({ matter, info, onChange }) => {
  const { api } = useAuth();
  if (!info?.regions?.length) return null;
  const deduced = info.regions.find((r) => r.code === info.deduced_region);
  const save = async (v) => {
    try { await api.patch(`/crm/matters/${matter.id}`, { region: v }); onChange(v); toast.success('Región guardada: los nuevos plazos descontarán sus feriados'); }
    catch { toast.error('No se pudo guardar la región'); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs text-slate-300">
      <span>Estado o región del caso:</span>
      <select data-testid="deadlines-region-select" value={info.region || ''} onChange={(e) => save(e.target.value)} className="bg-slate-800 border border-slate-600 rounded-lg px-2 py-1 text-xs text-white">
        <option value="">{deduced ? `Automático según tribunal (${deduced.name})` : 'Solo feriados nacionales'}</option>
        {info.regions.map((r) => <option key={r.code} value={r.code}>{r.name}</option>)}
      </select>
    </div>
  );
};
